import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useAuth } from '@/composables/useAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopFeatureStrip',
  setup(__props) {

/**
 * トップのメインバナー下にある3カラム帯（実績・スピード・シェア）。
 *
 * Top.vue（1,700行超）の分解で切り出した。3つ目のカラムが紹介キャンペーンの入口。
 *
 * 見た目は @/assets/scss/top/feature-strip.scss に全部あるので、この SFC は
 * import するだけ。親から渡すものは無い。
 *
 * 3つ目のカラムは紹介キャンペーンの入口。確認画面のポップアップと同じ
 * イラスト付きバナーを置き、マイページのキャンペーン枠（紹介URL・紹介の状況）へ送る。
 * 共有そのものはマイページ側の枠でやってもらう。未ログインは /mypage が
 * requiresAuth で素の /login へ飛ばされ、ログイン後に /mypage トップへ落ちるので、
 * frompage 付きでログインページへ送ってキャンペーン枠へ戻す。
 *
 * **文言はテンプレートに直書きする。** この帯は `scripts/extract-top-static.js` が
 * public/top-content.html へ静的抽出し、初回表示と SEO はそのHTMLが使われるため、
 * computed や JSON から差し込むと静的HTML側に `{{ }}` が残ってしまう。
 * キャンペーンの文言カタログ（referralCampaign.json）はここでは使わない。
 */
const { isAuthenticated } = useAuth()
const router = useRouter()

// トップにはログインダイアログが無いのでログインページへ送り、
// ログイン後にキャンペーン枠へ戻す（NewLogin.vue の frompage 分岐）
function onCampaignLinkClick(event: MouseEvent): void {
  if (isAuthenticated.value) return
  event.preventDefault()
  router.push({ path: '/login', query: { frompage: 'yagiprime_referral' } })
}

return { __sfc: true,isAuthenticated, router, onCampaignLinkClick }
}

})